/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { OrganisationOtherNameDTO } from './OrganisationOtherNameDTO';
import {
    OrganisationOtherNameDTOFromJSON,
    OrganisationOtherNameDTOFromJSONTyped,
    OrganisationOtherNameDTOToJSON,
    OrganisationOtherNameDTOToJSONTyped,
} from './OrganisationOtherNameDTO';
import type { SubjectDTO } from './SubjectDTO';
import {
    SubjectDTOFromJSON,
    SubjectDTOFromJSONTyped,
    SubjectDTOToJSON,
    SubjectDTOToJSONTyped,
} from './SubjectDTO';
import type { UrlDTO } from './UrlDTO';
import {
    UrlDTOFromJSON,
    UrlDTOFromJSONTyped,
    UrlDTOToJSON,
    UrlDTOToJSONTyped,
} from './UrlDTO';
import type { OrganisationInstitutionalIdDTO } from './OrganisationInstitutionalIdDTO';
import {
    OrganisationInstitutionalIdDTOFromJSON,
    OrganisationInstitutionalIdDTOFromJSONTyped,
    OrganisationInstitutionalIdDTOToJSON,
    OrganisationInstitutionalIdDTOToJSONTyped,
} from './OrganisationInstitutionalIdDTO';
import type { AdminDataOrganisationDTO } from './AdminDataOrganisationDTO';
import {
    AdminDataOrganisationDTOFromJSON,
    AdminDataOrganisationDTOFromJSONTyped,
    AdminDataOrganisationDTOToJSON,
    AdminDataOrganisationDTOToJSONTyped,
} from './AdminDataOrganisationDTO';
import type { OrganisationToPersonDTO } from './OrganisationToPersonDTO';
import {
    OrganisationToPersonDTOFromJSON,
    OrganisationToPersonDTOFromJSONTyped,
    OrganisationToPersonDTOToJSON,
    OrganisationToPersonDTOToJSONTyped,
} from './OrganisationToPersonDTO';
import type { ReferencedOrganisationDTO } from './ReferencedOrganisationDTO';
import {
    ReferencedOrganisationDTOFromJSON,
    ReferencedOrganisationDTOFromJSONTyped,
    ReferencedOrganisationDTOToJSON,
    ReferencedOrganisationDTOToJSONTyped,
} from './ReferencedOrganisationDTO';
import type { ReferencedProjectDTO } from './ReferencedProjectDTO';
import {
    ReferencedProjectDTOFromJSON,
    ReferencedProjectDTOFromJSONTyped,
    ReferencedProjectDTOToJSON,
    ReferencedProjectDTOToJSONTyped,
} from './ReferencedProjectDTO';
import type { ExternalIdDTO } from './ExternalIdDTO';
import {
    ExternalIdDTOFromJSON,
    ExternalIdDTOFromJSONTyped,
    ExternalIdDTOToJSON,
    ExternalIdDTOToJSONTyped,
} from './ExternalIdDTO';

/**
 * 
 * @export
 * @interface OrganisationDTO
 */
export interface OrganisationDTO  {
    /**
     * 
     * @type {number}
     * @memberof OrganisationDTO
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof OrganisationDTO
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDTO
     */
    name?: string;
    /**
     * 
     * @type {Array<OrganisationOtherNameDTO>}
     * @memberof OrganisationDTO
     */
    otherNames?: Array<OrganisationOtherNameDTO>;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDTO
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganisationDTO
     */
    oldId?: string;
    /**
     * 
     * @type {Date}
     * @memberof OrganisationDTO
     */
    startDate?: Date;
    /**
     * 
     * @type {Array<ReferencedProjectDTO>}
     * @memberof OrganisationDTO
     */
    projects?: Array<ReferencedProjectDTO>;
    /**
     * 
     * @type {Array<ReferencedOrganisationDTO>}
     * @memberof OrganisationDTO
     */
    parents?: Array<ReferencedOrganisationDTO>;
    /**
     * 
     * @type {Array<ReferencedOrganisationDTO>}
     * @memberof OrganisationDTO
     */
    childs?: Array<ReferencedOrganisationDTO>;
    /**
     * 
     * @type {Array<ReferencedOrganisationDTO>}
     * @memberof OrganisationDTO
     */
    successor?: Array<ReferencedOrganisationDTO>;
    /**
     * 
     * @type {Array<ReferencedOrganisationDTO>}
     * @memberof OrganisationDTO
     */
    predecessors?: Array<ReferencedOrganisationDTO>;
    /**
     * 
     * @type {Array<OrganisationToPersonDTO>}
     * @memberof OrganisationDTO
     */
    organisationPersons?: Array<OrganisationToPersonDTO>;
    /**
     * 
     * @type {Array<SubjectDTO>}
     * @memberof OrganisationDTO
     */
    organisationSubjects?: Array<SubjectDTO>;
    /**
     * 
     * @type {AdminDataOrganisationDTO}
     * @memberof OrganisationDTO
     */
    adminDataOrganisation?: AdminDataOrganisationDTO;
    /**
     * 
     * @type {Array<ExternalIdDTO>}
     * @memberof OrganisationDTO
     */
    externalIds?: Array<ExternalIdDTO>;
    /**
     * 
     * @type {Array<OrganisationInstitutionalIdDTO>}
     * @memberof OrganisationDTO
     */
    organisationInstitutionalIds?: Array<OrganisationInstitutionalIdDTO>;
    /**
     * 
     * @type {Array<UrlDTO>}
     * @memberof OrganisationDTO
     */
    urls?: Array<UrlDTO>;
}

/**
 * Check if a given object implements the OrganisationDTO interface.
 */
export function instanceOfOrganisationDTO(value: object): value is OrganisationDTO {
    return true;
}

export function OrganisationDTOFromJSON(json: any): OrganisationDTO {
    return OrganisationDTOFromJSONTyped(json, false);
}

export function OrganisationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganisationDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
                  'name': json['name'] == null ? undefined : json['name'],
              'otherNames': json['otherNames'] == null ? undefined : ((json['otherNames'] as Array<any>).map(OrganisationOtherNameDTOFromJSON)),
                  'note': json['note'] == null ? undefined : json['note'],
                  'oldId': json['oldId'] == null ? undefined : json['oldId'],
                'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
              'projects': json['projects'] == null ? undefined : ((json['projects'] as Array<any>).map(ReferencedProjectDTOFromJSON)),
              'parents': json['parents'] == null ? undefined : ((json['parents'] as Array<any>).map(ReferencedOrganisationDTOFromJSON)),
              'childs': json['childs'] == null ? undefined : ((json['childs'] as Array<any>).map(ReferencedOrganisationDTOFromJSON)),
              'successor': json['successor'] == null ? undefined : ((json['successor'] as Array<any>).map(ReferencedOrganisationDTOFromJSON)),
              'predecessors': json['predecessors'] == null ? undefined : ((json['predecessors'] as Array<any>).map(ReferencedOrganisationDTOFromJSON)),
              'organisationPersons': json['organisationPersons'] == null ? undefined : ((json['organisationPersons'] as Array<any>).map(OrganisationToPersonDTOFromJSON)),
              'organisationSubjects': json['organisationSubjects'] == null ? undefined : ((json['organisationSubjects'] as Array<any>).map(SubjectDTOFromJSON)),
                  'adminDataOrganisation': json['adminDataOrganisation'] == null ? undefined : AdminDataOrganisationDTOFromJSON(json['adminDataOrganisation']),
              'externalIds': json['externalIds'] == null ? undefined : ((json['externalIds'] as Array<any>).map(ExternalIdDTOFromJSON)),
              'organisationInstitutionalIds': json['organisationInstitutionalIds'] == null ? undefined : ((json['organisationInstitutionalIds'] as Array<any>).map(OrganisationInstitutionalIdDTOFromJSON)),
              'urls': json['urls'] == null ? undefined : ((json['urls'] as Array<any>).map(UrlDTOFromJSON)),
    };
}

export function OrganisationDTOToJSON(json: any): OrganisationDTO {
    return OrganisationDTOToJSONTyped(json, false);
}

export function OrganisationDTOToJSONTyped(value?: OrganisationDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'endDate': value['endDate']?.toISOString().substring(0,10),
        'name': value['name'],
        'otherNames': value['otherNames'] == null? value['otherNames']: (value['otherNames'] as Array<any>).map(OrganisationOtherNameDTOToJSON),
        'note': value['note'],
        'oldId': value['oldId'],
        'startDate': value['startDate']?.toISOString().substring(0,10),
        'projects': value['projects'] == null? value['projects']: (value['projects'] as Array<any>).map(ReferencedProjectDTOToJSON),
        'parents': value['parents'] == null? value['parents']: (value['parents'] as Array<any>).map(ReferencedOrganisationDTOToJSON),
        'childs': value['childs'] == null? value['childs']: (value['childs'] as Array<any>).map(ReferencedOrganisationDTOToJSON),
        'successor': value['successor'] == null? value['successor']: (value['successor'] as Array<any>).map(ReferencedOrganisationDTOToJSON),
        'predecessors': value['predecessors'] == null? value['predecessors']: (value['predecessors'] as Array<any>).map(ReferencedOrganisationDTOToJSON),
        'organisationPersons': value['organisationPersons'] == null? value['organisationPersons']: (value['organisationPersons'] as Array<any>).map(OrganisationToPersonDTOToJSON),
        'organisationSubjects': value['organisationSubjects'] == null? value['organisationSubjects']: (value['organisationSubjects'] as Array<any>).map(SubjectDTOToJSON),
        'adminDataOrganisation': AdminDataOrganisationDTOToJSON(value['adminDataOrganisation']),
        'externalIds': value['externalIds'] == null? value['externalIds']: (value['externalIds'] as Array<any>).map(ExternalIdDTOToJSON),
        'organisationInstitutionalIds': value['organisationInstitutionalIds'] == null? value['organisationInstitutionalIds']: (value['organisationInstitutionalIds'] as Array<any>).map(OrganisationInstitutionalIdDTOToJSON),
        'urls': value['urls'] == null? value['urls']: (value['urls'] as Array<any>).map(UrlDTOToJSON),
    };
}


